<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="订单编号：">
            <el-input v-model="query.orderNum" placeholder="请输入订单编号" clearable size="small" />
          </el-form-item>
          <el-form-item label="商品名称：">
            <el-input v-model="query.allGoodsName" placeholder="请输入商品名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input v-model="query.name" placeholder="请输入下单人/收件人姓名" clearable size="small" />
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model="query.phone" placeholder="请输入下单人/收件人手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="下单人身份：">
            <el-select v-model="query.custCLevel" placeholder="请选择" clearable size="small">
              <el-option :label="it.name" :value="it.level" v-for="it in fetchList" :key="it.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否包邮：">
            <el-select v-model="query.noFreight" placeholder="请选择" clearable size="small">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递类型：">
            <el-select v-model="query.deliveryOptionsId" placeholder="请选择" clearable size="small">
            <el-option v-for="it in deliveryAllList" :key="it.id || it.code || it.name" :label="it.name" :value="it.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号：">
            <el-input v-model="query.logisticsNumber" placeholder="请输入快递单号" clearable size="small" />
          </el-form-item>
          <el-form-item label="包裹数量：">
            <el-input v-model="query.parcelNum" placeholder="请输入包裹数量" clearable size="small" />
          </el-form-item>
          <el-form-item label="随货同行单：">
            <el-input v-model="query.customerIdcard" placeholder="请输入随货同行单抬头" clearable size="small" />
          </el-form-item>
          <el-form-item label="时间区域：">
            <el-select v-model="query.timeType" placeholder="请选择" clearable size="small">
              <el-option label="支付时间" :value="1"></el-option>
              <el-option label="创建时间" :value="2"></el-option>
              <el-option label="发货时间" :value="3"></el-option>
              <el-option label="完成时间" :value="4"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleClick" v-if="exchangeTotal">
          <el-tab-pane :label="'待发货('+ exchangeTotal.deliverNum +')'" name="2"></el-tab-pane>
          <el-tab-pane :label="'待收货('+ exchangeTotal.shippedNum +')'" name="3"></el-tab-pane>
          <el-tab-pane :label="'已完成('+ exchangeTotal.accomplishNum +')'" name="4"></el-tab-pane>
          <el-tab-pane :label="'待付款('+ exchangeTotal.unpaidNum +')'" name="1"></el-tab-pane>
          <el-tab-pane :label="'已取消('+ exchangeTotal.cancelNum +')'" name="0"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <!-- <el-button type="primary" size="mini" @click="addOrderToYongYou" plain v-hasPermi="['order:integralorder:push']">补推订单</el-button> -->
          <el-button type="primary" size="mini" @click="handleExport" plain v-hasPermi="['order:integralorder:export']">导出</el-button>
          <img src="../../../assets/Vector.png" class="vector" @click="handleChangeFields">
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" key="1" />
        <el-table-column :min-width="item.width" v-for="(item,index) in dynamicHeaders" :key="index" :prop="item.prop" :label="item.label" :fixed="item.prop === 'orderNum'" :sortable="item.isSortable" :show-overflow-tooltip="item.showToolTip">
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleShow(row)" v-if="item.prop === 'orderNum'">{{row.orderNum}}</el-link>
            <block v-else-if="item.prop === 'allPayMoney'">
              <div class="tableDiv-txt">
                <span>商品支付积分:{{row.allPayMoney}}</span>
                <span>邮费支付现金:{{row.freight}}</span>
                <span>支付总:{{row.allPayMoney}}积分<block v-if="row.freight>0">+{{row.freight}}元现金</block></span>
              </div>
            </block>
            <block v-else-if="item.prop === 'custName'">
              <div class="tableDiv-txt">
                <span>姓名:{{row.custName}}</span>
                <span>手机号:{{row.custPho}}</span>
                <span>所属区域:{{row.custAddrProvinceCodeName}}{{row.custAddrCityCodeName}}{{row.custAddrAreaCodeName}}</span>
              </div>
            </block>
            <block v-else-if="item.prop === 'name'">
              <div class="tableDiv-txt">
                <span>姓名:{{row.name}}</span>
                <span>手机号:{{row.phone}}</span>
                <span>收货地址:{{row.addrProvince}}{{row.addrCity}}{{row.addrArea}}{{row.addrDetail}}</span>
              </div>
            </block>
            <span v-else-if="item.prop === 'state'">{{ orderStatus(row.state) }}</span>
            <span v-else>{{ row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="230" v-if="+activeName === 2 || +activeName === 3 || +activeName === 4" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleUpOrder(row,2)" v-hasPermi="['order:integralorder:waybill']">添加运单号</el-button>
            <el-button type="text" @click="handleUpOrder(row,3)" v-if="+activeName === 2" v-hasPermi="['order:integralorder:push']">补推订单</el-button>
            <el-button type="text" @click="handleUpOrder(row,4)" v-if="+activeName === 1 || +activeName === 2 || +activeName === 3 || +activeName === 4">取消订单</el-button>
          </template>
        </el-table-column>
        <el-table-column label="取消时间" width="120" prop="finishTime" align="center" key="22" v-if="+activeName === 0" />
        <el-table-column label="取消原因" prop="refundReason" align="center" key="23" v-if="+activeName === 0" />
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 添加运单号 -->
    <el-dialog :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
      <el-form v-loading="fullscreenLoading" ref="form" :model="dialogQuery" label-width="100px" label-position="right" class="dialogDiv">
        <el-form-item label="快递公司">
          <el-select v-model="dialogQuery.deliveryOptionsId" placeholder="请选择" clearable size="small">
            <el-option v-for="(it,idx) in deliveryList" :key="idx" :label="it.name" :value="it.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="添加运单号">
          <el-input v-model="dialogQuery.orderNum" placeholder="请输入订单编号" clearable size="small" @input="validateOrderNum" :class="{ 'is-error': orderNumError }" />
          <div v-if="orderNumError" class="el-form-item__error">运单号只能包含数字和英文字母</div>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog" size="mini">取消</el-button>
          <el-button type="primary" @click="addLogisticsNumber" size="mini">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <change-fields-vue ref="fieldsPopup" :allTemplate="allTemplate" :cList="dynamicHeaders" @updated="doColumnList" />
  </div>
</template>
<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import { orderCancellationMessage } from '@/utils/order-cancellation-message'
import Pagination from '@/components/Pagination'
import changeFieldsVue from '@/views/common/changeFields.vue'
export default {
  components: {
    Pagination, changeFieldsVue
  },
  data() {
    return {
      query: {
        pageNo: 1,
        pageSize: 10,
        orderNum: undefined,
        type: 2,
        allGoodsName: undefined,
        orderPayType: undefined,
        name: undefined,
        phone: undefined,
        state: undefined,
        noFreight: undefined,
        deliveryOptionsId: undefined,
        logisticsNumber: undefined,
        parcelNum: undefined,
        customerIdcard: undefined,
        timeType: undefined,
        custCLevel: undefined,
      },
      dateTime: [],
      showMore: true,
      activeName: "2",
      listLoading: false,
      list: [],
      total: 0,
      exchangeTotal: null,
      dialogVisible: false,
      dialogQuery: {
        deliveryOptionsId: undefined,
        orderNum: undefined,
      },
      orderNumError: false,
      dialogItem: "",
      fetchList: [],
      deliveryList: [],
      deliveryAllList: [],
      multipleSelection: [],
      fullscreenLoading: false,
      allTemplate: [{ label: '订单编号', prop: 'orderNum' }, { label: '商品名称', prop: 'allGoodsName', showToolTip: true, width: '160px' },
      { label: '商品数量', prop: 'allBuyNum' }, { label: '快递方式', prop: 'deliveryOptionsName' },
      { label: '应支付金额', prop: 'allPayMoney', width: '170px' }, { label: '下单人信息', prop: 'custName', width: '170px' },
      { label: '收货信息', prop: 'name', width: '170px' }, { label: '随货同行单抬头', prop: 'customerIdcard' },
      { label: '下单时间', prop: 'createdTime', width: '160px' }, { label: '支付时间', prop: 'payTime', width: '160px' },
      { label: '发货时间', prop: 'sendTime', width: '160px' },
      { label: '完成时间', prop: 'finishTime', width: '160px' }, { label: '快递单号', prop: 'logisticsNumber' },
      { label: '包裹数量', prop: 'parcelNum' }, { label: '剩余发货商品件数', prop: 'notSendNum' }, { label: '状态', prop: 'state' },
      { label: '操作时间', prop: 'operatedTime', width: '160px' }, { label: '操作人', prop: 'operatedBy' }],
      dynamicHeaders: [],
    };
  },
  created() {
    this.getFetchList();
    this.doQueryList({})
    this.getAllDeliveryList();
    this.getFieled();
  },
  computed: {
    orderStatus() {
      return function (val) {
        switch (val) {
          case 0:
            return "已取消";
          case 1:
            return "待付款";
          case 2:
            return "待发货";
          case 3:
            return "待收货";
          case 4:
            return "已完成";
        }
      }

    }
  },
  methods: {
    handleExport() {
      this.$message && this.$message.info('导出功能开发中')
    },
    validateOrderNum(value) {
      if (!value) {
        this.orderNumError = false;
        return;
      }
      const pattern = /^[A-Za-z0-9]*$/;
      this.orderNumError = !pattern.test(value);
    },
    getFieled() {
      if (localStorage.getItem('integralTableColumn')) {
        let tColumn = JSON.parse(localStorage.getItem('integralTableColumn'))
        this.dynamicHeaders = tColumn
      } else {
        this.dynamicHeaders = this.allTemplate
      }
      console.log(this.dynamicHeaders)
    },
    handleChangeFields() {
      this.$refs.fieldsPopup.open();
    },
    doColumnList(checkedList) {
      if (checkedList && !checkedList.length) return
      let allList = JSON.parse(JSON.stringify(this.allTemplate))
      let newL = allList.filter(item => checkedList.indexOf(item.prop) > -1)
      this.dynamicHeaders = newL;
      console.log(newL)
      localStorage.setItem('integralTableColumn', JSON.stringify(newL))
    },
    getAllDeliveryList() {
      goodsOrderApi.getDeliveryList({ isEnable: true, orderType: 3 }).then(res => {
        let { list } = res.data;
        this.deliveryAllList = list;
      })
    },
    getFetchList() {
      goodsOrderApi.fetchList({}).then((data) => {
        this.fetchList = data.data;
      })
    },
    getAfterTotalNum() {
      let params = JSON.parse(JSON.stringify(this.query));
      delete params.state
      delete params.pageNo
      delete params.pageSize
      goodsOrderApi.getGoodsTotal(params).then((data) => {
        if (data.data) {
          this.exchangeTotal = data.data;
        } else {
          this.exchangeTotal = {
            deliverNum: 0, shippedNum: 0, accomplishNum: 0, unpaidNum: 0, cancelNum: 0
          }
        }
      })
    },
    calcQuery() {
      let { timeType } = this.query
      if (timeType && this.dateTime && this.dateTime.length > 0) {
        this.query.startTime = this.dateTime[0]
        this.query.endTime = this.dateTime[1]
      } else {
        this.query.startTime = undefined
        this.query.endTime = undefined
      }
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.calcQuery()
      this.getAfterTotalNum()
      this.query.state = +this.activeName
      this.listLoading = true
      return goodsOrderApi.getGoodsOrder(this.query).then(res => {
        let { list, total } = res.data;
        this.list = list;
        this.total = total;
      }).finally(() => {
        this.listLoading = false
      })
    },
    handleFilter() {
      this.query = { type: 2 };
      this.dateTime = [];
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    // 点击搜索
    handleQuery() {
      this.doQueryList({ pageNo: 1 });
    },
    // 切换订单类型
    handleClick(e) {
      this.doQueryList({ pageNo: 1 })
    },
    // 导出
    handleDownload() {
      return this.$common.confirm('是否确认导出')
        .then(() => goodsOrderApi.exportExcelGoods(this.query, 2))
    },
    handleExport() {
      this.$router.push("/export/list?code=ExportCustomerPointOrder,ExportCustomerPointOrderGoods&orderType=2")
    },
    changeShow() {
      this.showMore = !this.showMore;
    },
    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command,
      };
    },
    handleShow(row) {
      row.activeName = +this.activeName
      this.$emit('handleShow', row, 2)
    },
    // 1、复制订单   2、添加运单号   3、补推订单  4、取消订单
    handleUpOrder(row, type) {
      switch (type) {
        case 1:
          this.strtCopy(row.orderNum);
          break;
        case 2:
          this.openDialog(row);
          break;
        case 3:
          this.tuiOrder(row);
          break;
        case 4:
          this.cancelOrder(row);
          break;
      }
    },
    // 复制订单
    strtCopy(msg) {
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', msg); //msg:是我们需要复制的文字内容
      input.select();
      try {
        let result = document.execCommand("copy");
        document.body.removeChild(input);
        if (!result) {
          this.$message.warning("复制失败");
        } else {
          this.$message.success("复制成功");
        }
      } catch (e) {
        document.body.removeChild(input);
        this.$message.warning("当前浏览器不支持复制功能");
      }
    },
    // 添加运单号
    openDialog(row) {
      goodsOrderApi.getDeliveryList({ isEnable: true, orderType: 3 }).then(res => {
        let { list } = res.data;
        this.deliveryList = list;
        this.dialogVisible = true;
        this.dialogItem = row;
      })
    },
    closeDialog() {
      this.dialogVisible = false;
      this.fullscreenLoading = false;
      this.dialogItem = "";
    },
    addLogisticsNumber() {
      let { deliveryOptionsId, orderNum } = this.dialogQuery
      if (this.fullscreenLoading) return;
      if (deliveryOptionsId == undefined) return this.$message({ message: '请选择快递公司!' });
      if (orderNum == undefined) return this.$message({ message: '请填写运单号!' });
      let find = this.deliveryList.find(item => item.id === deliveryOptionsId)
      let obj = {
        orderId: this.dialogItem.id,
        deliveryCode: find.code,
        deliveryName: find.name,
        deliveryNum: orderNum,
        type: 2
      }
      this.fullscreenLoading = true;
      goodsOrderApi.addGoodsLogisticsNumber(obj).then(res => {
        this.fullscreenLoading = false;
        this.$message({ type: 'success', message: '添加成功!' });
        this.doQueryList({ pageNo: 1 });
        this.closeDialog();
      })
    },
    selectionChange(val) { this.multipleSelection = val; },
    // 补推订单
    addOrderToYongYou() {
      console.log(this.multipleSelection)
      if (!this.multipleSelection.length) return this.$message({ message: '请选择补推订单!' });
      let id = [];
      this.multipleSelection.forEach(it => {
        id.push(it.id)
      })
      id = id.join(',');
      this.$confirm('确定将本订单再一次推送到聚水潭平台中?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        this.goodsTuiOrder(id);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消补推订单'
        });
      });
    },
    tuiOrder(row) {
      this.$confirm('确定将本订单再一次推送到聚水潭平台中?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // center: true,
      }).then(() => {
        this.goodsTuiOrder(row.id.toString());
      }).catch(() => { });
    },
    goodsTuiOrder(id) {
      // let integers = id.split(",");
      goodsOrderApi.goodsTuiOrder({ orderid: id }).then(res => {
        this.$message({
          type: 'success',
          message: '推送成功!'
        });
      })
    },
    // 取消订单
    cancelOrder(row, type) {
      this.$prompt('请输入取消原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        inputPattern: /./,
        inputErrorMessage: '请输入取消原因'
      }).then(value => {
        let params = { orderId: row.id, refundReason: value.value }
        if (+this.activeName === 1) {
          goodsOrderApi.cancelGoodsOrder(params).then(res => {
            this.$message(orderCancellationMessage(res));
            this.doQueryList({});
          })
        } else {
          params.type = type ? 1 : 0
          goodsOrderApi.cancelOrder(params).then(res => {
            this.$message(orderCancellationMessage(res));
            this.doQueryList({});
          })
        }

      })
    },
  },
};
</script>
<style>
.block {
  padding: 20px 0;
}
.el-pagination {
  display: flex;
  justify-content: center;
}
.tableDiv-txt {
  display: flex;
  flex-direction: column;
}
.dialogDiv .el-select {
  display: block !important;
}
.vector {
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-left: 10px;
}
</style>
